const pageNameKey = "otaNavbar";

export const otaNavbarEn = {
  [pageNameKey]: {
    firmwareText: "Firmware",
    configurationsText: "Configurations",
    settingsText: "Settings",
  },
};

export const otaNavbarPtBr = {
  [pageNameKey]: {
    firmwareText: "Firmware",
    configurationsText: "Configurações",
    settingsText: "Configurações",
  },
};

export const otaNavbarDe = {
  [pageNameKey]: {
    firmwareText: "Firmware",
    configurationsText: "Konfigurationen",
    settingsText: "Einstellungen",
  },
};

export const otaNavbarZhHans = {
  [pageNameKey]: {
    firmwareText: "固件",
    configurationsText: "配置",
    settingsText: "设置",
  },
};

export const otaNavbarIt = {
  [pageNameKey]: {
    firmwareText: "Firmware",
    configurationsText: "Configurazioni",
    settingsText: "Impostazioni",
  },
};

export const otaNavbarEs = {
  [pageNameKey]: {
    firmwareText: "firmware",
    configurationsText: "Configuraciones",
    settingsText: "Configuración",
  },
};

export const otaNavbarNl = {
  [pageNameKey]: {
    configurationsText: "Configuraties",
    firmwareText: "Firmware",
    settingsText: "Instellingen",
  },
};

export const otaNavbarTr = {
  [pageNameKey]: {
    configurationsText: "Yapılandırmalar",
    firmwareText: "Ürün yazılımı",
    settingsText: "Ayarlar",
  },
};
